/**
 * Format Unix timestamp to Icelandic relative time string
 * @param {number} timestamp - Unix timestamp in seconds
 * @returns {string} Relative time in Icelandic (e.g. "12 min", "i gaer")
 */
export function formatTimeAgo(timestamp) {
  const now = Math.floor(Date.now() / 1000);
  const diff = now - timestamp;

  if (diff < 60) return `${diff} sek`;
  if (diff < 3600) return `${Math.floor(diff / 60)} mín`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} klst`;
  if (diff < 172800) return 'í gær';
  if (diff < 604800) return `${Math.floor(diff / 86400)} dögum`;
  if (diff < 2592000) return `${Math.floor(diff / 604800)} vikum`;
  return `${Math.floor(diff / 2592000)} mánuðum`;
}
